"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.pushEvent = void 0;
const axios_1 = __importDefault(require("axios"));
const pushEvent = (url, data) => {
    if (process.env.NODE_ENV === "development") {
        console.log(`Skipping sending to event-catcher: ${JSON.stringify(data)}`);
    }
    else {
        axios_1.default
            .post(url, data, {
            headers: {
                "Content-Type": "application/json"
            }
        })
            .catch((error) => {
            console.log(`Failed to send event to backend: ${error}`);
        });
    }
};
exports.pushEvent = pushEvent;
//# sourceMappingURL=push-event.js.map